import { LeftColumn, RightColumn, StaticPage } from './StaticPage';
import { Helpdesk } from './Helpdesk';
import { Address } from './Address';
import { css } from '@emotion/css';
import { Legal } from 'dg-web-shared/lib/legal/legal_module_imports.ts';

import ReactMarkdown from 'react-markdown';
import { Typo } from 'dg-web-shared/ui/typo.ts';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export function LegalPage() {
    const { language } = useLanguage();

    return (
        <StaticPage>
            <LeftColumn>
                <div
                    className={css({
                        ...Typo.body,

                        h1: {
                            fontSize: 22,
                            margin: '12px 0',
                        },
                        h2: {
                            fontSize: 12,
                            margin: 0,
                        },
                        h3: {
                            fontSize: 18,
                            marginTop: '12px',
                        },
                        h4: {
                            fontSize: 16,
                            marginTop: '8px',
                            marginBottom: 0,
                        },
                    })}
                >
                    <ReactMarkdown>
                        {Legal.privacyPolicyMarkdown[language]}
                    </ReactMarkdown>
                </div>
            </LeftColumn>
            <RightColumn>
                <Helpdesk />
                <Address />
            </RightColumn>
        </StaticPage>
    );
}
